import React, { Component } from 'react'
import intl from 'react-intl-universal'
import Modal from './Modal'
import RegisterForm from '../components/RegisterForm'

const BACKEND_AUTH_URL = 'https://auth.funoro.com'

class RegisterModal extends Component {
  render () {
    return (
      <Modal title='Register now'>
        <div className='b-auth-form'>
          <div className='b-form-row'>
            <a className='b-button b-button_fb b-button_x'
               href={BACKEND_AUTH_URL + '/login/facebook'}
            >
              {intl.get('Register with Facebook')}
            </a>
          </div>

          <div className='b-form-row'>
            <a className='b-button b-button_google b-button_x'
               href={BACKEND_AUTH_URL + '/login/google'}
            >
              {intl.get('Register with Google')}
            </a>
          </div>

          <div className='b-form-separator'><span>or</span></div>

          <RegisterForm />

        </div>
      </Modal>
    )
  }
}

export default RegisterModal



// WEBPACK FOOTER //
// ./src/containers/RegisterModal.js